/* VESPERA — theme.js */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const routes = window.routes || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    const fmt = window.moneyFormat || '{{amount_with_comma_separator}} zł';
    const v = (Number(cents) || 0) / 100;
    const withSep = (n, dec, th, ds) => {
      const parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(ds);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return withSep(v, 2, ',', '.');
        case 'amount_no_decimals': return withSep(v, 0, ',', '.');
        case 'amount_with_comma_separator': return withSep(v, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withSep(v, 0, '.', ',');
        case 'amount_with_space_separator': return withSep(v, 2, ' ', ',');
        case 'amount_with_apostrophe_separator': return withSep(v, 2, "'", '.');
        default: return withSep(v, 2, ' ', ',');
      }
    });
  }
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- Header ---------- */
  const header = $('[data-header]');
  if (header && header.classList.contains('site-header--overlay')) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  const menuBtn = $('[data-menu-toggle]');
  const mobileNav = $('[data-mobile-nav]');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', () => {
      const open = menuBtn.getAttribute('aria-expanded') === 'true';
      menuBtn.setAttribute('aria-expanded', String(!open));
      mobileNav.hidden = open;
      document.body.classList.toggle('no-scroll', !open);
      if (header) header.classList.toggle('is-scrolled', !open || window.scrollY > 40);
    });
  }

  /* ---------- Reveal on scroll ---------- */
  const revealEls = $$('[data-reveal]');
  if ('IntersectionObserver' in window && revealEls.length) {
    const io = new IntersectionObserver((entries) => {
      let n = 0;
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        if (!en.target.style.getPropertyValue('--d')) en.target.style.setProperty('--d', n++);
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-in'));
  }

  /* ---------- Wordmark fit: big name always spans the full width ---------- */
  const fitEls = $$('[data-fit]');
  const fit = () => {
    fitEls.forEach((el) => {
      el.style.fontSize = '';
      const range = document.createRange();
      range.selectNodeContents(el);
      const textW = range.getBoundingClientRect().width;
      const target = el.clientWidth * (Number(el.dataset.fit) || 0.98);
      if (!textW) return;
      const size = parseFloat(getComputedStyle(el).fontSize) * (target / textW);
      el.style.fontSize = Math.min(size, window.innerHeight * 0.62) + 'px';
    });
  };
  if (fitEls.length) {
    fit();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    let t; window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(fit, 120); });
  }

  /* ---------- Info pages: TOC, print, cookie settings ---------- */
  const toc = $('[data-toc]');
  const docBody = $('[data-doc]');
  if (toc && docBody) {
    const hs = $$('h2[id]', docBody);
    toc.innerHTML = hs.map((h) => `<a href="#${h.id}">${esc(h.textContent)}</a>`).join('');
    if ('IntersectionObserver' in window) {
      const links = $$('a', toc);
      const tio = new IntersectionObserver((ents) => ents.forEach((en) => {
        if (en.isIntersecting) links.forEach((l) => l.classList.toggle('is-active', l.getAttribute('href') === '#' + en.target.id));
      }), { rootMargin: '-20% 0px -70% 0px' });
      hs.forEach((h) => tio.observe(h));
    }
  }
  $$('[data-print]').forEach((b) => b.addEventListener('click', () => window.print()));
  const cookieBtn = $('[data-cookie-settings]');
  if (cookieBtn) {
    const ready = () => window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function';
    const reveal = () => { if (ready()) cookieBtn.hidden = false; };
    reveal(); window.addEventListener('load', reveal);
    cookieBtn.addEventListener('click', () => { if (ready()) window.privacyBanner.showPreferences(); });
  }

  /* ---------- Countdown ---------- */
  $$('[data-countdown]').forEach((el) => {
    const target = new Date(el.dataset.countdown);
    if (isNaN(target)) { el.remove(); return; }
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const diff = target - new Date();
      if (diff <= 0) { el.textContent = el.dataset.liveLabel || ''; return false; }
      const d = Math.floor(diff / 864e5);
      const h = Math.floor(diff / 36e5) % 24;
      const m = Math.floor(diff / 6e4) % 60;
      const s = Math.floor(diff / 1e3) % 60;
      el.textContent = `${d} d ${pad(h)} h ${pad(m)} m ${pad(s)} s`;
      return true;
    };
    if (tick()) { const id = setInterval(() => { if (!tick()) clearInterval(id); }, 1000); }
  });

  /* ---------- Drag-scroll (lookbook) ---------- */
  $$('[data-drag-scroll]').forEach((track) => {
    let down = false, startX = 0, startLeft = 0, moved = false;
    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', () => { down = false; track.classList.remove('is-dragging'); });
    track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  });

  /* ---------- Collection filters ---------- */
  const filterForm = $('[data-filter-form]');
  if (filterForm) {
    filterForm.addEventListener('change', () => {
      const params = new URLSearchParams(new FormData(filterForm));
      window.location.search = params.toString();
    });
    document.addEventListener('click', (e) => {
      $$('.filter[open]').forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
  }

  /* ---------- Product ---------- */
  const productEl = $('[data-product]');
  if (productEl) {
    const product = JSON.parse($('[data-product-json]', productEl).textContent);
    const form = $('[data-product-form]', productEl);
    const idInput = $('[data-variant-id]', productEl);
    const addBtn = $('[data-add]', productEl);
    const addLabel = $('[data-add-label]', productEl);
    const priceEl = $('[data-price]', productEl);
    const compareEl = $('[data-compare]', productEl);
    const fieldsets = $$('[data-option-index]', productEl);

    const selected = () => fieldsets.map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
    const findVariant = (opts) => product.variants.find((v) => v.options.every((o, i) => o === opts[i]));

    const markAvailability = () => {
      const opts = selected();
      fieldsets.forEach((fs, idx) => {
        $$('input', fs).forEach((input) => {
          const test = opts.slice(); test[idx] = input.value;
          const v = findVariant(test);
          const label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    };

    const update = () => {
      const v = findVariant(selected());
      if (!v) {
        addBtn.disabled = true; addLabel.textContent = 'Niedostępne';
        return;
      }
      idInput.value = v.id;
      const skuEl = $('[data-sku]', productEl);
      if (skuEl && v.sku) skuEl.textContent = v.sku;
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? 'Dodaj do koszyka' : 'Wyprzedane';
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) compareEl.textContent = v.compare_at_price > v.price ? formatMoney(v.compare_at_price) : '';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      if (v.featured_media) {
        const m = document.getElementById('Media-' + v.featured_media.id);
        if (m) m.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
      markAvailability();
    };
    fieldsets.forEach((fs) => fs.addEventListener('change', update));
    if (fieldsets.length) markAvailability();

    const guideBtn = $('[data-open-guide]', productEl);
    const guide = $('[data-guide]', productEl);
    if (guideBtn && guide) {
      guideBtn.addEventListener('click', () => { guide.open = true; guide.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    } else if (guideBtn) { guideBtn.remove(); }

    const gallery = $('[data-gallery]', productEl);
    const dots = $$('.pdp__dots span', productEl);
    if (gallery && dots.length) {
      gallery.addEventListener('scroll', () => {
        const i = Math.round(gallery.scrollLeft / gallery.clientWidth);
        dots.forEach((d, j) => d.classList.toggle('is-active', i === j));
      }, { passive: true });
    }

    if (form) {
      const errorEl = $('[data-form-error]', productEl);
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        addBtn.classList.add('is-loading');
        if (errorEl) errorEl.hidden = true;
        try {
          const res = await fetch(routes.cartAdd + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Nie udało się dodać do koszyka.');
          await Cart.open();
        } catch (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        } finally {
          addBtn.classList.remove('is-loading');
        }
      });
    }
  }

  /* ---------- Recommendations ---------- */
  $$('[data-recommendations]').forEach(async (el) => {
    if (el.children.length) return;
    try {
      const html = await fetch(el.dataset.url).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    } catch (_) { /* brak polecanych – sekcja zostaje pusta */ }
  });

  /* ---------- Cart drawer ---------- */
  const drawer = $('[data-cart-drawer]');
  let lastFocus = null;

  const Cart = {
    async get() { return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()); },
    async change(key, quantity) {
      const res = await fetch(routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      return res.json();
    },
    render(cart) {
      $$('[data-cart-count]').forEach((n) => {
        if (String(n.textContent) !== String(cart.item_count)) { n.classList.remove('is-bump'); void n.offsetWidth; n.classList.add('is-bump'); }
        n.textContent = cart.item_count;
      });
      if (!drawer) return;
      const lines = $('[data-cart-lines]', drawer);
      const foot = $('[data-cart-foot]', drawer);
      const total = $('[data-cart-total]', drawer);
      if (!cart.items.length) {
        lines.innerHTML = '<p class="empty">Koszyk jest pusty.</p>';
        foot.hidden = true;
        return;
      }
      foot.hidden = false;
      total.textContent = formatMoney(cart.total_price);
      lines.innerHTML = '<ul class="lines" role="list">' + cart.items.map((it) => {
        const img = it.image ? `<img src="${esc(it.image + (it.image.includes('?') ? '&' : '?') + 'width=240')}" alt="" width="72" height="90" loading="lazy">` : '';
        const variant = it.variant_title && it.variant_title !== 'Default Title' ? `<span class="line__variant">${esc(it.variant_title)}</span>` : '';
        return `<li class="line" data-key="${esc(it.key)}">
          <a class="line__img" href="${esc(it.url)}">${img}</a>
          <div class="line__info">
            <a class="line__title" href="${esc(it.url)}">${esc(it.product_title)}</a>
            ${variant}
            <span class="line__price">${formatMoney(it.final_line_price)}</span>
          </div>
          <div class="line__qty">
            <div class="qty">
              <button type="button" data-qty="${it.quantity - 1}" aria-label="Mniej">−</button>
              <span>${it.quantity}</span>
              <button type="button" data-qty="${it.quantity + 1}" aria-label="Więcej">+</button>
            </div>
            <button type="button" class="line__remove" data-qty="0">Usuń</button>
          </div>
        </li>`;
      }).join('') + '</ul>';
    },
    async open() {
      if (!drawer) { window.location.href = routes.cart; return; }
      const cart = await Cart.get();
      Cart.render(cart);
      lastFocus = document.activeElement;
      drawer.hidden = false;
      document.body.classList.add('no-scroll');
      $('.drawer__panel', drawer).focus();
    },
    close() {
      if (!drawer || drawer.hidden) return;
      const done = () => {
        drawer.hidden = true;
        drawer.classList.remove('is-closing');
        document.body.classList.remove('no-scroll');
        if (lastFocus) lastFocus.focus();
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { done(); return; }
      drawer.classList.add('is-closing');
      setTimeout(done, 340);
    }
  };
  window.VesperaCart = Cart;

  if (drawer) {
    $$('[data-cart-open]').forEach((a) => a.addEventListener('click', (e) => {
      if (document.body.classList.contains('template-cart')) return;
      e.preventDefault(); Cart.open();
    }));
    drawer.addEventListener('click', async (e) => {
      if (e.target.closest('[data-cart-close]')) { Cart.close(); return; }
      const q = e.target.closest('[data-qty]');
      if (q) {
        const line = q.closest('[data-key]');
        line.style.opacity = '.5';
        const cart = await Cart.change(line.dataset.key, Math.max(0, Number(q.dataset.qty)));
        Cart.render(cart);
      }
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !drawer.hidden) Cart.close(); });
  }
})();
